var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"order-name"},[_vm._v(_vm._s(_vm.orderName.slice(1)))])])}
var staticRenderFns = []

export { render, staticRenderFns }